"use strict";
exports.__esModule = true;
exports.typedArrayToBuffer = exports.byteLength = exports.bufferCompare = exports.utf8Decode = exports.utf8Encode = exports.hexDecode = exports.hexEncode = exports.base64Decode = exports.base64Encode = exports.toWordArray = exports.toArrayBuffer = exports.toBuffer = exports.isBuffer = exports.hexCharSet = exports.base64CharSet = void 0;
var tslib_1 = require("tslib");
var enc_hex_1 = require("crypto-js/build/enc-hex");
var enc_utf8_1 = require("crypto-js/build/enc-utf8");
var enc_base64_1 = require("crypto-js/build/enc-base64");
var lib_typedarrays_1 = tslib_1.__importDefault(require("crypto-js/build/lib-typedarrays"));
var platform_1 = tslib_1.__importDefault(require("platform"));
/* Most BufferUtils methods that return a binary object return an ArrayBuffer
 * if supported, else a CryptoJS WordArray. The exception is toBuffer, which
 * returns a Uint8Array (and won't work on browsers too old to support it) */
var ArrayBuffer = platform_1["default"].ArrayBuffer;
var atob = platform_1["default"].atob;
var TextEncoder = platform_1["default"].TextEncoder;
var TextDecoder = platform_1["default"].TextDecoder;
exports.base64CharSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
exports.hexCharSet = '0123456789abcdef';
function isWordArray(ob) {
    return ob !== null && ob !== undefined && ob.sigBytes !== undefined;
}
function isArrayBuffer(ob) {
    return ob !== null && ob !== undefined && ob.constructor === ArrayBuffer;
}
function isTypedArray(ob) {
    return !!ArrayBuffer && ArrayBuffer.isView && ArrayBuffer.isView(ob);
}
// https://gist.githubusercontent.com/jonleighton/958841/raw/f200e30dfe95212c0165ccf1ae000ca51e9de803/gistfile1.js
function uint8ViewToBase64(bytes) {
    var base64 = '';
    var encodings = exports.base64CharSet;
    var byteLength = bytes.byteLength;
    var byteRemainder = byteLength % 3;
    var mainLength = byteLength - byteRemainder;
    var a, b, c, d;
    var chunk;
    // Main loop deals with bytes in chunks of 3
    for (var i = 0; i < mainLength; i = i + 3) {
        // Combine the three bytes into a single integer
        chunk = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
        // Use bitmasks to extract 6-bit segments from the triplet
        a = (chunk & 16515072) >> 18; // 16515072 = (2^6 - 1) << 18
        b = (chunk & 258048) >> 12; // 258048   = (2^6 - 1) << 12
        c = (chunk & 4032) >> 6; // 4032     = (2^6 - 1) << 6
        d = chunk & 63; // 63       = 2^6 - 1
        // Convert the raw binary segments to the appropriate ASCII encoding
        base64 += encodings[a] + encodings[b] + encodings[c] + encodings[d];
    }
    // Deal with the remaining bytes and padding
    if (byteRemainder == 1) {
        chunk = bytes[mainLength];
        a = (chunk & 252) >> 2; // 252 = (2^6 - 1) << 2
        // Set the 4 least significant bits to zero
        b = (chunk & 3) << 4; // 3   = 2^2 - 1
        base64 += encodings[a] + encodings[b] + '==';
    }
    else if (byteRemainder == 2) {
        chunk = (bytes[mainLength] << 8) | bytes[mainLength + 1];
        a = (chunk & 64512) >> 10; // 64512 = (2^6 - 1) << 10
        b = (chunk & 1008) >> 4; // 1008  = (2^6 - 1) << 4
        // Set the 2 least significant bits to zero
        c = (chunk & 15) << 2; // 15    = 2^4 - 1
        base64 += encodings[a] + encodings[b] + encodings[c] + '=';
    }
    return base64;
}
function base64ToArrayBuffer(base64) {
    var binary_string = atob === null || atob === void 0 ? void 0 : atob(base64); // this will always be defined in browser so it's safe to cast
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
        var ascii = binary_string.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes.buffer;
}
function isBuffer(buffer) {
    return isArrayBuffer(buffer) || isWordArray(buffer) || isTypedArray(buffer);
}
exports.isBuffer = isBuffer;
/* In browsers, returns a Uint8Array */
function toBuffer(buffer) {
    if (!ArrayBuffer) {
        throw new Error("Can't convert to Buffer: browser does not support the necessary types");
    }
    if (isArrayBuffer(buffer)) {
        return new Uint8Array(buffer);
    }
    if (isTypedArray(buffer)) {
        return new Uint8Array(buffer.buffer);
    }
    if (isWordArray(buffer)) {
        /* Backported from unreleased CryptoJS
         * https://code.google.com/p/crypto-js/source/browse/branches/3.x/src/lib-typedarrays.js?r=661 */
        var arrayBuffer = new ArrayBuffer(buffer.sigBytes);
        var uint8View = new Uint8Array(arrayBuffer);
        for (var i = 0; i < buffer.sigBytes; i++) {
            uint8View[i] = (buffer.words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
        }
        return uint8View;
    }
    throw new Error('BufferUtils.toBuffer expected an arraybuffer, typed array, or CryptoJS wordarray');
}
exports.toBuffer = toBuffer;
function toArrayBuffer(buffer) {
    if (isArrayBuffer(buffer)) {
        return buffer;
    }
    return toBuffer(buffer).buffer;
}
exports.toArrayBuffer = toArrayBuffer;
function toWordArray(buffer) {
    if (isTypedArray(buffer)) {
        buffer = buffer.buffer;
    }
    return isWordArray(buffer) ? buffer : lib_typedarrays_1["default"].create(buffer);
}
exports.toWordArray = toWordArray;
function base64Encode(buffer) {
    if (isWordArray(buffer)) {
        return enc_base64_1.stringify(buffer);
    }
    return uint8ViewToBase64(toBuffer(buffer));
}
exports.base64Encode = base64Encode;
function base64Decode(str) {
    if (ArrayBuffer && atob) {
        return base64ToArrayBuffer(str);
    }
    return enc_base64_1.parse(str);
}
exports.base64Decode = base64Decode;
function hexEncode(buffer) {
    return enc_hex_1.stringify(toWordArray(buffer));
}
exports.hexEncode = hexEncode;
function hexDecode(string) {
    var wordArray = enc_hex_1.parse(string);
    return ArrayBuffer ? toArrayBuffer(wordArray) : wordArray;
}
exports.hexDecode = hexDecode;
function utf8Encode(string) {
    if (TextEncoder) {
        return new TextEncoder().encode(string).buffer;
    }
    return enc_utf8_1.parse(string);
}
exports.utf8Encode = utf8Encode;
/* For utf8 decoding we apply slightly stricter input validation than to
 * hexEncode/base64Encode/etc: in those we accept anything that Buffer.from
 * can take (in particular allowing strings, which are just interpreted as
 * binary); here we ensure that the input is actually a buffer since trying
 * to utf8-decode a string to another string is almost certainly a mistake */
function utf8Decode(buffer) {
    if (!isBuffer(buffer)) {
        throw new Error('Expected input of utf8decode to be an arraybuffer, typed array, or CryptoJS wordarray');
    }
    if (TextDecoder && !isWordArray(buffer)) {
        return new TextDecoder().decode(buffer);
    }
    buffer = toWordArray(buffer);
    return enc_utf8_1.stringify(buffer);
}
exports.utf8Decode = utf8Decode;
function bufferCompare(buffer1, buffer2) {
    if (!buffer1)
        return -1;
    if (!buffer2)
        return 1;
    var wordArray1 = toWordArray(buffer1);
    var wordArray2 = toWordArray(buffer2);
    wordArray1.clamp();
    wordArray2.clamp();
    var cmp = wordArray1.sigBytes - wordArray2.sigBytes;
    if (cmp != 0)
        return cmp;
    var words1 = wordArray1.words;
    var words2 = wordArray2.words;
    for (var i = 0; i < words1.length; i++) {
        cmp = words1[i] - words2[i];
        if (cmp != 0)
            return cmp;
    }
    return 0;
}
exports.bufferCompare = bufferCompare;
function byteLength(buffer) {
    if (isArrayBuffer(buffer) || isTypedArray(buffer)) {
        return buffer.byteLength;
    }
    else if (isWordArray(buffer)) {
        return buffer.sigBytes;
    }
}
exports.byteLength = byteLength;
/* Returns ArrayBuffer on browser and Buffer on Node.js */
function typedArrayToBuffer(typedArray) {
    return typedArray.buffer;
}
exports.typedArrayToBuffer = typedArrayToBuffer;
